import React from 'react';

import { Col } from 'antd';
import cn from 'classnames';
import gv from 'get-value';
import PropTypes from 'prop-types';

import styles from './styles.scss';

function XDFShowText({ it, size, model }) {
  const { id, prop, label, span } = it;

  const val = gv(model, prop);
  return (
    <Col span={span || 24}>
      <div className={styles.formItem}>
        <div className={styles.formItemLabel}>
          <label htmlFor={id}>{label}</label>
        </div>
        <div className={cn(styles.formItemField, { [styles.small]: size === 'small' })}>
          <div id={id} className={styles.showDateTime}>
            {val === undefined ? '' : val}
          </div>
        </div>
      </div>
    </Col>
  );
}

XDFShowText.propTypes = {
  it: PropTypes.shape({
    id: PropTypes.string.isRequired,
    prop: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    span: PropTypes.number,
  }).isRequired,
  size: PropTypes.string.isRequired,
  model: PropTypes.shape({}).isRequired,
};

export default XDFShowText;
